import Axios from "axios"
import { htmlOrderTemplate } from "../../../utilities/htmlOrderTemplate.js"
import html2pdf from 'html2pdf.js';

export const HEADER_INFO = [
    {
        label: "Warehouse",
        property: "name"
    },
    {
        label: "Location",
        property: "address"
    },
    {
        label: "Hours",
        property: "hours"
    },
    {
        label: "Warehouse supervisor",
        property: "supervisor"
    },
]

export const PRODUCTS_TABS = [
    "Products",
    "Purchase orders",
]

export const TABLE_TAB_HEADER = {
    "Products": [
        {
            title: "Barcode",
            property: "barcode"
        },
        {
            title: "Name",
            property: "name"
        },
        // {
        //     title: "Stock",
        //     property: "stock"
        // },
        {
            title: "Category",
            property: "commodity"
        },
    ],
    "Purchase orders": [
        {
            title: "Folio",
            property: "folio"
        },
        {
            title: "Location",
            property: "locationName"
        },
        {
            title: "Category",
            property: "category"
        },
        {
            title: "Order date",
            property: "orderDate"
        },
        {
            title: "Status",
            property: "status"
        },
    ]
}

export const MODAL_INPUTS = [
    {
        label: "Name",
        placeholder: "Warehouse name",
        property: "name"
    },
    {
        label: "Supervisor",
        placeholder: "Name of supervisor",
        property: "supervisor"
    },
    {
        label: "Hours",
        placeholder: "Available schedule",
        property: "hours"
    },
    {
        label: "City",
        placeholder: "City name",
        property: "city"
    },
    {
        label: "State",
        placeholder: "State name",
        property: "state"
    },
    {
        label: "Address",
        placeholder: "Street name, number, ZIP Code",
        property: "address"
    },
]

export const PO_STATUS = {
    inPreparation: "In preparation",
    sent: "Sent",
    delivered: "Delivered",
}

export const ABLE_TO_DO_ROLS = [
    "Master",
    "Supplier",
    "Product manager",
    "Super admin"
]

export const getTextToShow = (warehouse, property) => {
    if (property === "address") {
        return `${warehouse?.[property]} ${warehouse?.city}, ${warehouse?.state}`
    }

    return warehouse?.[property]
}

export const filterProducts = (productsList, searchValue) => {
    return productsList.filter(item => item.barcode.toUpperCase().includes(searchValue.toUpperCase()))
}

export const updateProdIdsRemovedFromWarehouse = (actualState, previousState, warehouseId) => {
    const prodOutOfWarehouse = actualState.filter(item => !item.inWarehouse)
    const prodIdsOutOfWarehouse = previousState.map(previous => {
        return prodOutOfWarehouse.some(item => item.barcode === previous.barcode) ? previous._id : null
    }).filter(item => item !== null)

    if (prodIdsOutOfWarehouse.length === 0) return

    const dataToSend = {
        specificProductIds: prodIdsOutOfWarehouse,
        warehouseId: warehouseId
    }

    Axios.put(`${process.env.REACT_APP_PURCHASING_LOCALHOST}supplier/deactivateProducts`, dataToSend).then(res => {
        console.log(res.data)
    }).catch(err => console.log(err))
}

export const generateOrderPdf = async (order) => {
        const productsHtml = order.products.map(product => `
            <div class="tableRow">
                <span class="rowValue">${product?.specificProduct?.barcode}</span>
                <span class="rowValue">${product?.specificProduct?.name}</span>
                <span class="rowValue">${product?.quantity ?? 0}</span>
                <span class="rowValue">${(product?.specificProduct?.packaging * product?.quantity)?.toString()?.padStart(2, '')}</span>
                <span class="rowValue">${product?.specificProduct?.unitsPerPackage * (product?.specificProduct?.packaging * product?.quantity)?.toString()?.padStart(2, '')}</span>
                <span class="rowValue">$${product?.specificProduct?.price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                <span class="rowValue">$${(product?.specificProduct?.price * product?.quantity).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>
        `).join('');

        const totalOrderPrice = order.products
            .reduce((total, product) => total + (product?.specificProduct?.price * product?.quantity), 0)
            .toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const html = htmlOrderTemplate
            .replace('{{folio}}', order?.folio)
            .replace('{{supplierRFC}}', order?.supplier?.rfc)
            .replace('{{supplierName}}', order?.supplier?.name)
            .replace('{{clientName}}', order?.locationName)
            .replace('{{clientAddress}}', `${order?.address} ${order?.zipCode} ${order?.county}, ${order?.state}`)
            .replace('<!-- products -->', productsHtml)
            .replace('{{totalOrderPrice}}', totalOrderPrice);

        const opt = {
            margin: 0,
            filename: `order_${order._id}.pdf`,
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().from(html).set(opt).save();
    };
